import { call, delay, put, takeLatest } from 'redux-saga/effects';

import { objToFormData } from 'utils';
import { postBookError } from 'modules/manager/containers/Booking/services/actions';
import {
  cleanErrorBook,
  clearIddp,
  createCellRequest,
  createCellSuccess,
  getOrdersBookError,
  getOrdersBookRequest,
  getOrdersBookSuccess,
  getOrdersOzmError,
  getOrdersOzmSuccess,
} from './actions';

import { SAPService } from '../../../entities/SAP/service';
import { ReservationsService, ReservCell } from '../../../entities/Reservations';
import { CREATE_CELL_REQUEST, GET_ORDERS_BOOK_REQUEST, GET_ORDERS_OZM_REQUEST } from './constants';

function* getOrdersBookSaga(action: ReturnType<typeof getOrdersBookRequest>) {
  const { orderObject, bookValue, roleId } = action.payload;
  const idx = bookValue.orders.findIndex((o: any) => o.orderObject === orderObject);

  try {
    let wrongIddp;
    // @ts-ignore
    const data: any = yield call(SAPService.getReservationsSAP, orderObject, roleId);
    const copiedOrdersFromPayload = [...bookValue.orders];
    if (bookValue.orders.length === 1 || bookValue.orders[0].company.iddp === data.company.iddp) {
      copiedOrdersFromPayload[idx] = { ...data };
      const updatedOrdersDoubled = { ...bookValue, orders: copiedOrdersFromPayload };
      wrongIddp = false;
      yield put(getOrdersBookSuccess(updatedOrdersDoubled, data, wrongIddp));
    } else {
      copiedOrdersFromPayload[idx] = {
        reservationId: '',
        orderParts: [],
        orderObject: '',
        precomplentation: false,
        isCompleted: false,
        isSmcCar: false,
        company: {
          name: '',
          contactPerson: null,
        },
      };
      const updatedOrders = { ...bookValue, orders: copiedOrdersFromPayload };
      wrongIddp = true;
      yield put(getOrdersBookSuccess(updatedOrders, data, wrongIddp));
      yield delay(5000);
      yield put(clearIddp());
    }
  } catch (error: any) {
    yield put(
      getOrdersBookError(
        {
          error,
          orderObject,
          idx,
        },
        bookValue,
      ),
    );
  }
}

function* getOrdersOzmSaga(action: ReturnType<typeof getOrdersBookRequest>) {
  const { orderObject, roleId } = action.payload;

  try {
    // @ts-ignore
    const data: any = yield call(SAPService.getOZMSAP, orderObject, roleId);
    yield put(getOrdersOzmSuccess(data));
  } catch (error: any) {
    yield put(getOrdersOzmError(error.errorExtraParams));
  }
}

function* createCellSaga(action: ReturnType<typeof createCellRequest>) {
  try {
    const { checkInDate, checkOutDate, isBlocked } = action;
    const branchLocal = localStorage.getItem('branchId');
    const branch = JSON.parse(branchLocal || 'null');

    const body = {
      branchId: branch.id,
      checkInDate,
      checkOutDate,
      isBlocked,
      cellSettingId: branch.cellSetting.id,
      IsDeleted: false,
    };

    const book: ReservCell = yield call(ReservationsService.postReservationsCell, objToFormData(body));

    yield put(createCellSuccess(book));
  } catch (error: any) {
    yield put(postBookError(error));
    yield put(cleanErrorBook());
  }
}

export function* bookingModalWatcher() {
  yield takeLatest(CREATE_CELL_REQUEST, createCellSaga);
  yield takeLatest(GET_ORDERS_BOOK_REQUEST, getOrdersBookSaga);
  yield takeLatest(GET_ORDERS_OZM_REQUEST, getOrdersOzmSaga);
}
